import type { RequireNotesInterface } from 'store/units/types';
import type { UnitInfoTextInterface } from './';

interface AddNotesTexts {
  textArray: UnitInfoTextInterface[];
  unitInfo: RequireNotesInterface;
}
export const addNotesTexts = ({ textArray, unitInfo }: AddNotesTexts): void => {
  if (
    unitInfo.display.displayNotes.noteOne &&
    typeof unitInfo.notes?.noteOne !== 'undefined'
  ) {
    textArray.push({ text: `${unitInfo.notes.noteOne}` });
  }
  if (
    unitInfo.display.displayNotes.noteTwo &&
    typeof unitInfo.notes?.noteTwo !== 'undefined'
  ) {
    textArray.push({ text: `${unitInfo.notes.noteTwo}` });
  }
  if (
    unitInfo.display.displayNotes.noteThree &&
    typeof unitInfo.notes?.noteThree !== 'undefined'
  ) {
    textArray.push({
      text: `${unitInfo.notes.noteThree}`,
    });
  }

  if (
    unitInfo.display.displayNotes.noteFour &&
    typeof unitInfo.notes?.noteFour !== 'undefined'
  ) {
    textArray.push({
      text: `${unitInfo.notes.noteFour}`,
    });
  }

  if (
    unitInfo.display.displayNotes.noteFive &&
    typeof unitInfo.notes?.noteFive !== 'undefined'
  ) {
    textArray.push({
      text: `${unitInfo.notes.noteFive}`,
    });
  }
};
